import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Batasi akses Master Data ke user yang punya flag `access_role.master_data` = 1
 * (dicek toleran angka/string via AuthService.canMasterData). Beda dari app lama
 * yang cuma sembunyiin menu di sidebar tanpa proteksi route. Kalau gak berhak →
 * balik ke /dashboard.
 */
export const masterDataGuard: CanActivateChildFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.canMasterData()) return true;

  router.navigateByUrl('/dashboard');
  return false;
};
